export default __webpack_public_path__ + "static/media/gr-20-corcega-track-completo.a30138e6.gpx";